import { render, staticRenderFns } from "./component-map-t.vue?vue&type=template&id=2483bb70"
import script from "./component-map-t.vue?vue&type=script&lang=js"
export * from "./component-map-t.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports